import API from "@/services/api";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Profile from "./profile";

export default function View() {
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState();
  const [activeTab, setActiveTab] = useState("profile");
  const { id } = useParams();

  async function getData() {
    setLoading(true);
    try {
      const { ok, code, data } = await API.get(`/malt_profile/${id}`);
      if (!ok) {
        throw new Error(code);
      }
      setProfile(data);
    } catch (error) {
      console.error("Error fetching profile:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
  }, [id]);

  if (loading) {
    return <div className="p-8">Loading...</div>;
  }

  return (
    <div className="m-8 p-8 rounded shadow bg-white">
      <h1 className="text-2xl font-bold mb-4">{profile?.full_name}</h1>
      <a href={`https://www.malt.fr/profile/${profile?.username}`} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline mb-4 block">
        View Profile on Malt
      </a>
      <p className="text-gray-700 mb-4">Last Scraped: {new Date(profile?.scraped_at).toLocaleDateString()}</p>

      <div className="flex border-b border-gray-200 mb-4">
        <button
          onClick={() => setActiveTab("profile")}
          className={`px-4 py-2 text-sm font-medium ${activeTab === "profile" ? "text-blue-600 border-b-2 border-blue-600" : "text-gray-500 hover:text-gray-700"}`}>
          Profile
        </button>
        <button
          onClick={() => setActiveTab("raw")}
          className={`px-4 py-2 text-sm font-medium ${activeTab === "raw" ? "text-blue-600 border-b-2 border-blue-600" : "text-gray-500 hover:text-gray-700"}`}>
          Raw Data
        </button>
      </div>

      {activeTab === "profile" && <Profile profile={profile} />}
      {activeTab === "raw" && <RawData profile={profile} />}

      <button onClick={() => window.history.back()} className="mt-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
        Back to List
      </button>
    </div>
  );
}

export function RawData({ profile }) {
  return (
    <div className="space-y-4">
      <h3 className="font-medium text-gray-900">Raw Profile Data</h3>
      <pre className="text-xs text-gray-600 overflow-auto max-h-[600px] whitespace-pre-wrap">{JSON.stringify(profile, null, 2)}</pre>
    </div>
  );
}